import cx from 'classnames';
import './MetaRow.css';

/**
 * QHS MetaRow
 * -----------
 * Horizontal strip of label/value pairs separated by 3px dot
 * dividers. Used in `PatientHero`, `PatientBanner`, and other
 * page-level identity strips. Items with `value == null || ''`
 * are skipped so callers can pass the full set unconditionally.
 *
 * Optional `trailing` slot (e.g. an `AllergyChip`) is rendered
 * after the last value WITHOUT a separator before it — designed
 * for non-meta content that visually rides the same row.
 *
 *   <MetaRow
 *     items={[
 *       { label: 'MRN', value: 'M-7702348811', mono: true },
 *       { label: 'DOB', value: '10/07/1993', mono: true },
 *       { label: 'Phone', value: '+1 (223) 344-5565' },
 *     ]}
 *     trailing={<AllergyChip />}
 *   />
 */
const MetaRow = ({ items = [], trailing, className, ...rest }) => {
  const visibleItems = items.filter(
    (item) => item && item.value !== null && item.value !== undefined && item.value !== ''
  );

  return (
    <div className={cx('qhs-meta-row', className)} {...rest}>
      {visibleItems.map((item, index) => (
        <span
          key={item.label || index}
          className='qhs-meta-row__item'
        >
          {index > 0 && <span className='qhs-meta-row__sep' aria-hidden='true' />}
          {item.label && <span className='qhs-meta-row__label'>{item.label}</span>}
          <span
            className={cx('qhs-meta-row__value', {
              'qhs-meta-row__value--mono': item.mono,
            })}
          >
            {item.value}
          </span>
        </span>
      ))}
      {trailing && <span className='qhs-meta-row__trailing'>{trailing}</span>}
    </div>
  );
};

export default MetaRow;
